import { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Http from 'services/http2';
import Validation from 'services/validation';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = theme => ({
  paper: {
    margin: '10px',
    width: '90vw',
  },
});

class SendSmscode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smsCodeSending: false,
      remaining: '获取验证码',
      showCaptcha: false,
      rd: 0,
    };
    this.validationConfig = this.validationConfig.bind(this);
    this.mobile = '';
    this.areaCode = '+86';
    this.smsType = '1'; //1注册 2重置密码 3修改手机
    this.countdownTime = 10;
    this.timer = 0;
    this.error = {};
    this.captcha = '';
  }

  init() {}

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {}

  validationConfig() {
    let obj = {
      '+86': 'mobile',
      '+852': 'mobile8',
      '+853': 'mobile8',
      '+886': 'mobile9',
    };
    let rule = obj[this.areaCode];
    return {
      mobile: { value: this.mobile, rules: ['required', rule] },
    };
  }

  showCaptcha() {
    if (!Validation.validateAll(this.validationConfig(), this.error)) {
      alert('无效的手机号码');
      return;
    }
    this.setState({ showCaptcha: true });
  }

  handleClose() {
    this.setState({ showCaptcha: false });
  }

  changeCaptch() {
    let rd = Math.random();
    this.setState({ rd: rd });
  }

  handleChange(event) {
    let val = event.target.value;
    this.setState({ captcha: val });
  }

  getSmsCode() {
    if (this.state.smsCodeSending) {
      return;
    }

    let postbody = {
      mobile: this.mobile,
      mobileArea: this.areaCode,
      apiPath: '/sysUser/valifyRegMobile',
    };
    Http.post('/api/user', postbody).then(response => {
      if (response.success) {
        postbody.captcha = this.state.captcha;
        postbody.smsType = this.smsType;
        postbody.apiPath = '/sms/getAuthCode';

        Http.post('/api/user', postbody).then(res => {
          if (res.success) {
            this.countDown();
            this.setState({ showCaptcha: false });
          } else {
            alert(res.errorMsg);
          }
        });
      } else {
        alert(response.errorMsg);
      }
    });
  }

  countDown() {
    this.setState({ smsCodeSending: true });
    this.setState({ remaining: this.countdownTime });
    this.timer = setInterval(() => {
      this.tick();
    }, 1000);
  }

  tick() {
    if (this.state.remaining === 0) {
      clearInterval(this.timer);
      this.setState({
        smsCodeSending: false,
        remaining: '获取验证码',
      });
    } else {
      this.setState({ remaining: this.state.remaining - 1 });
    }
  }

  render() {
    const { areaCode, mobile, smsType } = this.props;
    this.areaCode = areaCode;
    this.mobile = mobile;
    this.smsType = smsType;
    const { classes, data } = this.props;
    return (
      <div>
        <div
          className={`send-smscode ${this.smsCodeSending ? 'gray' : ''}`}
          onClick={() => {
            this.showCaptcha();
          }}
        >
          {this.state.remaining}
        </div>

        <Dialog
          classes={{ paper: classes.paper }}
          open={this.state.showCaptcha}
          onClose={() => this.handleClose()}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            请输入图片中CAPTCHA码
          </DialogTitle>
          <DialogContent>
            <div>
              <p>
                <img
                  title="captcha"
                  src={'/captcha/' + this.state.rd}
                  onClick={() => this.changeCaptch()}
                  alt="captcha"
                />
              </p>
              <p>
                <input
                  type="text"
                  name="captcha"
                  onChange={e => this.handleChange(e)}
                  placeholder=""
                />
              </p>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleClose()} color="primary">
              取消
            </Button>
            {
              <Button onClick={() => this.getSmsCode()} color="primary">
                确定
              </Button>
            }
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default connect()(withStyles(styles)(SendSmscode));
